import { render, staticRenderFns } from "./warningRecordList.vue?vue&type=template&id=04483a88&scoped=true"
import script from "./warningRecordList.vue?vue&type=script&lang=js"
export * from "./warningRecordList.vue?vue&type=script&lang=js"
import style0 from "./warningRecordList.vue?vue&type=style&index=0&id=04483a88&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04483a88",
  null
  
)

export default component.exports